module.exports = __webpack_public_path__ + "img/img_3.3a5af287.png";